import { Box, Typography, Accordion, AccordionSummary, AccordionDetails, Container } from "@mui/material";
import ExpandMoreIcon from "@mui/icons-material/ExpandMore";
import { faqs } from "./utils";

export function FAQSection() {
  return (
    <Box sx={{ bgcolor: "#152343", py: 10, px: 2, color: "#fff" }}>
      <Container>
        <Typography variant="h3" textAlign="center" mb={6}>
          Perguntas Frequentes
        </Typography>

        {faqs.map((faq, idx) => (
          <Accordion
            key={idx}
            sx={{
              bgcolor: "#1b2a57",
              color: "#fff",
              mb: 2,
              "& .MuiAccordionSummary-root": { px: 3 },
              "& .MuiAccordionDetails-root": { px: 3 },
            }}
          >
            <AccordionSummary expandIcon={<ExpandMoreIcon sx={{ color: "#fff" }} />}>
              <Typography fontWeight={600}>{faq.question}</Typography>
            </AccordionSummary>
            <AccordionDetails>
              <Typography whiteSpace="pre-line">{faq.answer}</Typography>
            </AccordionDetails>
          </Accordion>
        ))}
      </Container>
    </Box>
  );
}
